
import React, { useState, useEffect, useCallback, Fragment, useRef } from 'react';
import { getStats, handleSetCurrentEntity } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import Modal from "components/common/modal"
import ColorPicker from 'components/pages/livefeed/Editor/EditorContainer/common/ColorPicker'
import ReactTooltip from "react-tooltip";
import { livefeedStyle } from 'components/pages/livefeed/defaultstate'
import Gauge from 'components/pages/livefeed/Editor/EditorContainer/common/Gauge'
import update from 'immutability-helper';
import { updateGaugleTitle } from 'actions/livefeed'
import { isLightColor } from 'components/common/utils'


const RightPanel = ({
    scaleMode, dispatch, livefeedSlide, editorView, stepNumberState, nodeMap, sensorMap,
    handleOpenLocationModal }) => {

    function renderView() {
        const { fontFamily, historyEntities, rightPanelTextTitle, rightPanelBg, rightPanelGaugeValueLabel,
            rightPanelGaugeOccupiedBg, rightPanelGaugeOffsetdBg, rightPanelGaugeNeedle,
            floorplanOptions: { locationsID, widgetLabelType, isStandbyAsUnOccupied } }
            = livefeedSlide
        let history = historyEntities.slice();
        let currentEntity = history[stepNumberState];
        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
        let refinedLocationsID = locationsID.filter(id => nodeMap[id])
        const setCurrentEntitySwitch = (e, entity) => {
            e.preventDefault();
            e.stopPropagation();
            handleSetCurrentEntity(currentEntity, entity, dispatch)
        }
        return (
            <RightPanelView
                handleOpenLocationModal={handleOpenLocationModal}
                setCurrentEntitySwitch={(e, entity) => setCurrentEntitySwitch(e, entity)}
                fontFamily={fontFamily}
                currentEntity={currentEntity}
                editorView={editorView}
                rightPanelBg={rightPanelBg}
                rightPanelTextTitle={rightPanelTextTitle}
                rightPanelGaugeOccupiedBg={rightPanelGaugeOccupiedBg}
                rightPanelGaugeOffsetdBg={rightPanelGaugeOffsetdBg}
                rightPanelGaugeNeedle={rightPanelGaugeNeedle}
                rightPanelGaugeValueLabel={rightPanelGaugeValueLabel}
                widgetLabelType={widgetLabelType}
                isStandbyAsUnOccupied={isStandbyAsUnOccupied}
                locationsID={refinedLocationsID}
                nodeMap={nodeMap}
                sensorMap={sensorMap}
                dispatch={dispatch}
                scaleMode={scaleMode}
            />
        )
    }
    return (
        <Fragment>
            {(livefeedSlide.slideType !== "summary" && livefeedSlide.slideType !== "locationsList") &&
                renderView()
            }
        </Fragment>
    )
}
export default RightPanel

const RightPanelView = (props) => {
    const { scaleMode, dispatch, nodeMap, locationsID, sensorMap, widgetLabelType, setCurrentEntitySwitch, currentEntity,
        editorView, rightPanelTextTitle, rightPanelBg, rightPanelGaugeValueLabel, isStandbyAsUnOccupied,
        rightPanelGaugeOccupiedBg, rightPanelGaugeOffsetdBg, rightPanelGaugeNeedle,
        fontFamily, handleOpenLocationModal } = props

    const colorPickerRef = useRef(null)

    let isAllAreas = false; let isMR = false; let isOA = false; // isMeetingRooms// isOpenAreas
    let stats = []
    let i = 0;
    if (locationsID) {
        while (i < locationsID.length) {
            if (locationsID[i] !== undefined) {
                let node = nodeMap[locationsID[i]]
                switch (node.type) {
                    case "meeting_room":
                        isMR = true
                        stats.push(getStats(node, sensorMap, isStandbyAsUnOccupied))
                        i++
                        break;
                    case "open_area":
                        isOA = true
                        stats.push(getStats(node, sensorMap, isStandbyAsUnOccupied))
                        i++
                        break;
                    default:
                        i++
                }
            }
            if (isOA && isMR) {
                isAllAreas = true
            }
        }
    }
    let sumMr = 0; let sumOARooms = 0; let sumSensors = 0;
    let sumInUsedDesks = 0; let sumInUsedMr = 0; let sumInUsedOA = 0;
    for (let i = 0, n = stats.length; i < n; i++) {
        const { allSensors, allDesksInUse, meetingRooms, meetingRoomsInuse, openAreaRooms, openAreaRoomsInUse } = stats[i]
        sumMr += meetingRooms
        sumSensors += allSensors
        sumOARooms += openAreaRooms
        sumInUsedDesks += allDesksInUse
        sumInUsedMr += meetingRoomsInuse
        sumInUsedOA += openAreaRoomsInUse
    }


    let roomsValues = [50, 100]
    let totalMeetingRooms = null
    if (stats.length > 0) {
        if (isMR) {
            totalMeetingRooms = sumMr
            roomsValues = [sumMr - sumInUsedMr, sumMr];
        }
        if (isOA) {
            // dont assign value to totalMeetingRooms since we only need to display
            // the second widget for meeting_room type for now
            roomsValues = [sumOARooms - sumInUsedOA, sumOARooms];
        }
        if (isAllAreas) {
            totalMeetingRooms = sumMr
            roomsValues = [sumMr - sumInUsedMr, totalMeetingRooms];
        }

    }
    return (
        <Fragment>
            <div
                className="pane right"
                style={{
                    pointerEvents: `${editorView && !scaleMode ? 'all' : 'none'}`,
                    backgroundColor: rightPanelBg.color,
                    fontFamily: fontFamily,
                    width: livefeedStyle.rightPaneWidth + "%"
                }}>
                <div className="card-outer-container"
                    style={{
                        marginTop: 18 * (scaleMode ? 0.375 : 1),
                        height: `calc(100% - ${51.7 * (scaleMode ? 0.375 : 1)}px)`
                    }}
                >
                    {sumSensors ?
                        <GaugeCard
                            scaleMode={scaleMode}
                            widgetLabelType={widgetLabelType}
                            rightPanelGaugeValueLabel={rightPanelGaugeValueLabel}
                            rightPanelTextTitle={rightPanelTextTitle}
                            editorView={editorView}
                            currentEntity={currentEntity}
                            setCurrentEntitySwitch={setCurrentEntitySwitch}
                            rightPanelGaugeOccupiedBg={rightPanelGaugeOccupiedBg}
                            colorPickerRef={colorPickerRef}
                            rightPanelGaugeOffsetdBg={rightPanelGaugeOffsetdBg}
                            rightPanelGaugeNeedle={rightPanelGaugeNeedle}
                            index={0}
                            values={sumSensors ? [sumSensors - sumInUsedDesks, sumSensors] : [50, 100]}
                            dispatch={dispatch}
                        />
                        : <Fragment>
                            <p onClick={handleOpenLocationModal}
                                style={{
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    width: '80%',
                                    margin: 'auto auto',
                                    color: isLightColor(rightPanelBg.color) ? 'black' : 'white'
                                }}
                            >Please, click to choose Senzolive Location</p>
                        </Fragment>
                    }
                    {totalMeetingRooms ?
                        <GaugeCard
                            scaleMode={scaleMode}
                            widgetLabelType={widgetLabelType}
                            rightPanelGaugeValueLabel={rightPanelGaugeValueLabel}
                            rightPanelTextTitle={rightPanelTextTitle}
                            editorView={editorView}
                            currentEntity={currentEntity}
                            setCurrentEntitySwitch={setCurrentEntitySwitch}
                            rightPanelGaugeOccupiedBg={rightPanelGaugeOccupiedBg}
                            colorPickerRef={colorPickerRef}
                            rightPanelGaugeOffsetdBg={rightPanelGaugeOffsetdBg}
                            rightPanelGaugeNeedle={rightPanelGaugeNeedle}
                            index={1}
                            values={roomsValues}
                            dispatch={dispatch}
                        />
                        : null
                    }
                </div>
                <div className="logo-outer-container" style={{
                    bottom: 13.5 * (scaleMode ? 0.375 : 1)
                }}>
                    <img style={{
                        width: 45.83 * (scaleMode ? 0.375 : 1)
                    }} src="src/assets/icons/senzolive-logo.svg" alt="senzolive-logo" />
                </div>
                <ColorPicker
                    ref={colorPickerRef}
                />
            </div>
        </Fragment>
    );
}
const GaugeCard = (props) => {
    React.useEffect(() => {
        ReactTooltip.rebuild()// componentDidUpdate()
    })
    const { scaleMode, index, dispatch, values, widgetLabelType, rightPanelGaugeValueLabel, rightPanelTextTitle, editorView, currentEntity, setCurrentEntitySwitch,
        rightPanelGaugeOccupiedBg, colorPickerRef, rightPanelGaugeOffsetdBg, rightPanelGaugeNeedle } = props
    const [rightPanelTextTitleState, setGaugleTitleState] = useState('')
    const rightPanelTextTitleRef = useRef(null);

    /*Fallback for old previous livefeeds */
    const defaultTitle = rightPanelTextTitle.contents ?
        rightPanelTextTitle.contents[index] : (index === 0 ? 'Available desks' : 'Available meeting rooms')

    useEffect(() => {
        setGaugleTitleState(defaultTitle)
    }, [defaultTitle, index, rightPanelTextTitle.contents])

    const [isEditMode, setisEditMode] = useState(false)

    const inputOnchange = useCallback((e) => {
        if (isEditMode) {
            setGaugleTitleState(e.target.value)
        }
    }, [isEditMode])

    const confirmEditTitle = useCallback((e) => {
        e.preventDefault()
        e.stopPropagation()
        const newobjectText = update(rightPanelTextTitle, {
            contents: { [index]: { $set: rightPanelTextTitleState } }
        });
        dispatch(updateGaugleTitle(newobjectText));
        rightPanelTextTitleRef.current.close()
    }, [dispatch, index, rightPanelTextTitle, rightPanelTextTitleState])

    function inputDoubleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        setisEditMode(true)
        rightPanelTextTitleRef.current.open()
    }
    let gaugeValueLabelAlign;
    switch (rightPanelGaugeValueLabel.align) {
        case "left":
            gaugeValueLabelAlign = "flex-start";
            break;
        case "right":
            gaugeValueLabelAlign = "flex-end";
            break;
        case "center":
            gaugeValueLabelAlign = "center"
            break;
    }
    const titleTip = `Click and choose toolbar options to change text style <br /> Double click to edit text`;
    return (
        <Fragment>
            <div className="card-container" >
                <div className="card-top" style={{
                    textAlign: rightPanelTextTitle.align,
                    padding: `0 ${10 * (scaleMode ? 0.375 : 1)}px`,
                    marginBottom: 10 * (scaleMode ? 0.375 : 1)
                }}>
                    <div
                        data-tip={titleTip}
                        className={`card-title`}
                        onClick={(e) => setCurrentEntitySwitch(e, rightPanelTextTitle)}
                        onDoubleClick={(e) => inputDoubleClick(e)}
                        style={{
                            zIndex: 3,
                            color: rightPanelTextTitle.color,
                            fontSize: rightPanelTextTitle.size * (scaleMode ? 0.375 : 1),
                            fontWeight: rightPanelTextTitle.textStyle.bold ? 'bold' : 'unset',
                            fontStyle: rightPanelTextTitle.textStyle.italic ? 'italic' : 'unset',
                            textDecoration: rightPanelTextTitle.textStyle.underline ? 'underline' : 'unset'
                        }}>
                        {defaultTitle}
                        <span className={`${editorView ? 'card-title__editor-border' : 'card-title__preview'} ${currentEntity.id === "rightPanelTextTitle" ? 'card-title__editor-border_active' : ''}`} />
                    </div>

                </div>
                <ReactTooltip multiline={true} place="top" type="dark" effect="solid" />

                <div className={`card-svg`}
                    style={{
                        justifyContent: gaugeValueLabelAlign,
                        userSelect: 'none',
                        width: `${50} % `
                    }} >
                    {/* click able svg areas */}
                    <div style={{ borderColor: `${editorView ? `${rightPanelTextTitle.color}` : 'none'}` }}
                        className={`card-svg__editor ${editorView ? '' : 'card-svg__preview'}`} >
                        {editorView &&
                            <React.Fragment>
                                <div className={`rect rect_occupied ${currentEntity.id === "rightPanelGaugeOccupiedBg" ? 'rect_occupied_active' : ''}`}
                                    data-tip="Click to change gauge's occupied color"
                                    onClick={(e) => {
                                        setCurrentEntitySwitch(e, rightPanelGaugeOccupiedBg)
                                        colorPickerRef.current.openColorPicker()
                                    }}
                                />
                                <div className={`rect ${currentEntity.id === "rightPanelGaugeOffsetdBg" ? 'rect_active' : ''}`}
                                    data-tip="Click to change gauge's offset color"
                                    onClick={(e) => {
                                        setCurrentEntitySwitch(e, rightPanelGaugeOffsetdBg)
                                        colorPickerRef.current.openColorPicker()
                                    }}
                                />
                                <div className={`needle ${currentEntity.id === "rightPanelGaugeNeedle" ? 'needle_active' : ''}`}
                                    data-tip="Click to change the needle's color"
                                    onClick={(e) => {
                                        setCurrentEntitySwitch(e, rightPanelGaugeNeedle)
                                        colorPickerRef.current.openColorPicker()
                                    }}
                                />
                            </React.Fragment>
                        }
                    </div>
                    <Gauge
                        values={values}
                        rightPanelGaugeOffsetdBg={rightPanelGaugeOffsetdBg}
                        rightPanelGaugeOccupiedBg={rightPanelGaugeOccupiedBg}
                        rightPanelGaugeNeedle={rightPanelGaugeNeedle}
                        widgetLabelType={widgetLabelType}
                        currentEntity={currentEntity}
                        widgetStyle={{
                            borderColor: `${editorView ? `${rightPanelGaugeValueLabel.color}` : 'transparent'}`,
                            color: rightPanelGaugeValueLabel.color,
                            fontSize: rightPanelGaugeValueLabel.size,
                            fontWeight: rightPanelGaugeValueLabel.textStyle.bold ? 'bold' : 'unset',
                            fontStyle: rightPanelGaugeValueLabel.textStyle.italic ? 'italic' : 'unset',
                            textDecoration: rightPanelGaugeValueLabel.textStyle.underline ? 'underline' : 'unset'
                        }}
                        setCurrentEntitySwitch={(e) => setCurrentEntitySwitch(e, rightPanelGaugeValueLabel)}
                    />
                </div>
            </div >
            <Modal
                ref={rightPanelTextTitleRef}
                onClose={() => setGaugleTitleState(defaultTitle)}
                clickButton={(e) => confirmEditTitle(e)}
                header="Edit gauge chart title"
                buttonText="Confirm"
                buttonClass="btn-success"
                entry={null}
            >
                <input
                    value={rightPanelTextTitleState}
                    name={rightPanelTextTitleState}
                    onChange={(e) => inputOnchange(e)} type="text" />
            </Modal>

        </Fragment >
    );
}



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/RightPanel/index.jsx